import React from 'react'
import PropTypes from 'prop-types'
import styles from './HorizontalLineSlatePlugin.scss'
import {hasHorizontalLineByKey} from './HorizontalLineSlatePluginContainer'
import EditorTooltip from '../EditorTooltip'
import { ButtonGroup, Button, UncontrolledTooltip } from 'reactstrap'
import InsertEmptySpaceButton from '../InsertEmptySpaceButton'
import { FaTrash } from 'react-icons/lib/fa'

class HorizontalLineNode extends React.Component {
  constructor (props) {
    super(props)
    this.state = {isHovered: false}
  }

  onRemove = () => {
    this.props.editor.onChange(this.props.state
      .transform()
      .removeNodeByKey(this.props.node.key)
      .apply()
    )
  }

  render () {
    const { attributes, state, node, editor: { onChange } } = this.props
    const target = 'hr' + node.key
    const isOpen = hasHorizontalLineByKey(state, node.key)
    const isOpenAndFocused = isOpen && state.isFocused
    const tooltipProps = {
      state,
      isOpen,
      target
    }
    return <div {...attributes}
      id={target}
      className={styles.hrContainer + ' ' + (isOpenAndFocused ? styles.focused : '')}>
      <hr className={styles.hr} />
      <EditorTooltip {...tooltipProps} placement='top'>
        <ButtonGroup>
          <InsertEmptySpaceButton
            before after
            block={state.startBlock}
            state={state}
            onChange={onChange} />
          <Button onClick={this.onRemove} id={target + 'trash'} color='danger'><FaTrash /></Button>
          <UncontrolledTooltip target={target + 'trash'}>Remove Horizontal Line</UncontrolledTooltip>
        </ButtonGroup>
      </EditorTooltip>
    </div>
  }
}

HorizontalLineNode.propTypes = {
  editor: PropTypes.object,
  attributes: PropTypes.object,
  state: PropTypes.object,
  node: PropTypes.object
}

export default HorizontalLineNode



// WEBPACK FOOTER //
// ./src/components/HorizontalLineSlatePlugin/HorizontalLineNode.js